const FILTER_PRIORITY = "FILTER-PRIORITY"
const REMOVE_PRIORITY = "REMOVE-PRIORITY"
const FILTER_LABEL = "FILTER-LABEL"
const REMOVE_LABEL = "REMOVE-LABEL"
const FILTER_COLOR = "FILTER-COLOR"
const REMOVE_COLOR = "REMOVE-COLOR"
const CLEAR_FILTERS = "CLEAR-FILTERS"
const SORT_BY_DATE = "SORT_BY_DATE"

export { 
    FILTER_PRIORITY, 
    REMOVE_PRIORITY, 
    FILTER_LABEL, 
    REMOVE_LABEL, 
    FILTER_COLOR, 
    REMOVE_COLOR, 
    CLEAR_FILTERS,
    SORT_BY_DATE
}